<template>
	<v-layout align-space-between column fill-height w-100>
		<v-flex bg-gray-ultra-dark shrink text-xs-right>
		</v-flex>
	</v-layout>
</template>
<script type="plain/text">
import SSOService from '@/scripts/services/sso.service';
import LoginResultType from "@/scripts/models/enums/loginResultType.enum";
import Person from "@/scripts/models/person.model";
import { Routes } from "@/scripts/models/enums/routes.enum";
import CommonHelper from "@/scripts/helpers/common.helper";

export default {
  data() {
    return {
      ssoService: new SSOService(),
      person: new Person(),
    };
  },
  created() {
    const code = this.$route.query.code;
    const state = this.$route.query.state;

    const storageState = localStorage.getItem('STATE');
    const storageNonce = localStorage.getItem('NONCE');
    const storageCodeVerifier = localStorage.getItem('CODE_VERIFIER');

    if (code && state && storageState === state) {
      this.ssoService.callback(code, state, storageCodeVerifier)
        .then((response) => {
          this.onLogin(response.data);
          this.$router.push('/');
        })
        .catch(err => {
          console.error('Erro no callback:', err);
        });
    } else {
      console.log('Erro no callback: Parâmetros inválidos');
    }
  },
  methods:{
    onLogin(loginResult) {
      if (loginResult.success == LoginResultType.Success) {        
        this.$store.commit("REMOVE_ROLES");
        this.person = new Person();
        this.userService.listRolesOfLoggedUser().then(
          function (data) {
            this.$store.commit("SET_ROLES", data);
            this.setLoggedTrue();
            this.$emit("loginSuccess");

            if (this.$router.currentRoute.name == Routes.web.Login) {
              this.$router.push({ name: Routes.app.DashboardPF });
            } else if (
              ![
                Routes.web.CartLogged,
                Routes.app.CampaignLandingPage,
                Routes.web.ProjectLP,
                Routes.app.VolunteeringLP
              ].includes(this.$router.currentRoute.name)
            ) {
              this.$router.go();
            }
          }.bind(this)
        );
      } else if (loginResult.success == LoginResultType.MissingInfo) {
        if (loginResult.loginMessageWarning) {
          CommonHelper.swal(loginResult.loginMessageWarning, "", "warning");
        }
        this.missingPersonInfo = loginResult.missingPersonInfo;
        this.setStep(5);
      } else {
        this.setLogged(false);
        if (loginResult.loginMessageWarning) {
          CommonHelper.swal(loginResult.loginMessageWarning, "", "warning");
        }

        if (loginResult.tempHash) {
          this.$router.push({
            name: Routes.web.LoginPasswordRegistration,
            params: { tempHash: tempHash },
          });
        }
      }
    },
  }
};
</script>
